import { cn } from '@discover-lib/utils';
import { type RestaurantTagType } from '@discover-data/stores/restaurant/gql/fragments/restaurantTag';
import { type PeopleOption } from '@discover-data/stores/hooks/people/options';
import EmptyMessageResetButton from '@discover-components/restaurant/list/emptyMessage/resetButton';
import EmptyMessageSubtext from '@discover-components/restaurant/list/emptyMessage/subtext';
import EmptyMessageTitle from '@discover-components/restaurant/list/emptyMessage/title';

export type RestaurantMapEmptyMessageProps = {
  tags: RestaurantTagType[];
  className?: string;
  peopleOptions?: PeopleOption[] | null;
  minDiners?: PeopleOption | null;
  maxDiners?: PeopleOption | null;
};

export default function RestaurantMapEmptyMessage({
  tags,
  className,
  peopleOptions,
  minDiners,
  maxDiners,
}: RestaurantMapEmptyMessageProps) {
  return (
    <div
      className={cn(
        'prose flex max-w-none flex-col items-center gap-2 p-4 text-center lg:gap-4 lg:p-8',
        className
      )}>
      <EmptyMessageTitle className="text-md" />
      <EmptyMessageSubtext
        defaultMessage="Move the map to search another area."
        peopleOptions={peopleOptions}
        minDiners={minDiners}
        maxDiners={maxDiners}
      />
      <EmptyMessageResetButton tags={tags} />
    </div>
  );
}
